import { createActionGroup, emptyProps } from '@ngrx/store';

export const UserProfileMenuAnalyticsActions = createActionGroup({
  source: 'User Profile Menu - Analytics',
  events: {
    'Refer A Friend Clicked': emptyProps(),
  },
});
